/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
/* eslint-disable arrow-body-style */
import { ViewModelForm, ViewModelServiceContext } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import _ from 'lodash';
import { Flex } from '@jutro/layout'
import cx from 'classnames'
import { IntlContext, TranslatorContext } from "@jutro/locale";
import TWIADateFormatUtil from "ent-capability-quoteandbind-common-react/util/TWIADateFormatUtil";
import RoofsAndAdditionAccordion from '../RoofsAndAdditionAccordion/RoofsAndAdditionAccordion';
import CoverageSummaryAccordion from '../CoverageSummaryAccordion/CoverageSummaryAccordion';
import styles from '../TWIABuildingSummaryAccordions/TWIABuildingSummaryAccordions.module.scss';
import metadata from './PolicyBuildingAccordion.metadata.json5';
import messages from './PolicyBuildingAccordion.messages';


function PolicyBuildingAccordion(props) {
    // US28766 and US28769
    const {   data: location, index, path: locationPath, isPolicySummary, isRenewalSummary} = props;
    const translator = useContext(TranslatorContext)
    const intlContext = useContext(IntlContext);
    const viewModelService = useContext(ViewModelServiceContext);
    
    const isBuildersRisk = () => {
        const isRisk = location.buildings.filter(e => e.coverageForm === 'TWCR');
        return (isRisk.length > 0);
    };
    
    const createRoofAndRepairs_TWIA = useCallback((building) => {
        const items = [];
        const roofUpdates = _.get(building, 'construction_TWIA.roofUpdateDtls_TWIA');
        const repairAdditions = _.get(building, 'construction_TWIA.repairAdditionsDTO_TWIA');

        if (!_.isUndefined(roofUpdates)) {
            roofUpdates.forEach((entry) => {
                items.push({
                    type: translator(messages.roofUpdate),
                    date: TWIADateFormatUtil.formatDate(entry.roofUpdateDate),
                    cert: _.isUndefined(entry.hasWPI8CertOfCompIssued_TWIA) ? translator(messages.NotApplicable) : (entry.hasWPI8CertOfCompIssued_TWIA) ? 'Yes' : 'No', // DE17180
                    desc: entry.roofUpdateType,
                });
            });
        }

        if (!_.isUndefined(repairAdditions)) {
            repairAdditions.forEach((entry) => {
                items.push({
                    type: translator(messages.repairsAdditions),
                    date: TWIADateFormatUtil.formatDate(entry.repairDate),
                    cert: _.isUndefined(entry.hasWPI8CertOfCompIssued_TWIA) ? translator(messages.NotApplicable) : (entry.hasWPI8CertOfCompIssued_TWIA) ? 'Yes' : 'No', // DE17180
                    desc: entry.repairDesc
                });
            });
        }

        return items.sort((a, b) => {
            return a.date - b.date;
        });

    }, [])

    const buildingHeader = (i, building, premium) => {
        const formatterCurrency = intlContext.formatNumber(premium.amount, {
            style: 'currency',
            currency: premium.currency
        });
        // DE17188
        const description = _.get(building, 'description');

        if (isBuildersRisk()) {
            return (
                <div>
                    <Flex className={styles.fullWidth}>
                        <div className={cx(styles.heading, styles.headingBold, styles.flexOneFourth)}>
                            {translator(messages.BuildingTitle)}&nbsp;&nbsp;{_.get(building, 'buildingNumber')}
                        </div>
                        <div className={cx(styles.heading, styles.flexOneFourth)}>
                            {description}
                        </div>
                        <div className={cx(styles.heading, styles.flexOneFourth, styles.displayPremium)}>
                            {formatterCurrency}
                        </div>
                    </Flex>
                </div>
            )
        }

        return (
            <div>
                <Flex className={styles.fullWidth}>
                    <div className={cx(styles.heading, styles.headingBold, styles.flexOneFourth)}>
                        {translator(messages.BuildingTitle)}&nbsp;&nbsp;{_.get(building, 'buildingNumber')}
                    </div>
                    <div className={cx(styles.heading, styles.flexOneFourth)}>
                        {description}
                    </div>
                    <div className={cx(styles.heading, styles.flexOneFourth, styles.displayPremium)}>
                        {formatterCurrency}
                    </div>
                </Flex>
            </div>
        )
    }

    const generateTopicOverrides = useCallback(() => {
        if(location === undefined) {
            return [];
        }
        const overrides = location?.buildings?.map((building, i) => {
            const elt = _.extend({}, building)
            const buildingVM = viewModelService.create(elt, 'pc', 'edge.capabilities.policyjob.lob.commercialproperty.coverables.dto.BuildingDTO');
            
            const construction = _.get(buildingVM, 'construction_TWIA.constructionType_TWIA')?.value;
            const constructionType = construction !== undefined ? translator({
                id: construction.name,
                defaultMessage: construction.name
            }) : translator(messages.NotApplicable);
            const covForm = _.get(buildingVM, 'coverageForm')?.value;
            const CoverageFrom = covForm !== undefined ? translator({
                id: covForm.name,
                defaultMessage: covForm.name
            }) :  translator(messages.NotApplicable);
            const riskItemType_TWIA = _.get(buildingVM, 'riskItemType_TWIA')?.value;
            const riskItem = riskItemType_TWIA !== undefined ? translator({
                id: riskItemType_TWIA.name,
                defaultMessage: riskItemType_TWIA.name
            }) : translator(messages.NotApplicable);;
            const roof = _.get(buildingVM, 'construction_TWIA.roofType_TWIA')?.value;
            const roofType = roof !== undefined ? translator({
                id: roof.name,
                defaultMessage: roof.name
            }) : translator(messages.NotApplicable);
            
            return {
                [`buildingCard${i}`]: {
                    title: buildingHeader( i+1,building,building.premium),
                },
                [`buildingNumber${i}`]: {
                    value: _.get(building, 'buildingNumber') === undefined ? translator(messages.NotApplicable) :  _.get(building, 'buildingNumber')
                },
                [`constructionType${i}`]: {
                    value: constructionType
                },
                [`unitNumber${i}`]: {
                    value: _.get(building, 'unitNum_TWIA') === undefined ? translator(messages.NotApplicable) : _.get(building, 'unitNum_TWIA')
                },
                [`noOfStories${i}`]: {
                    value: _.get(building, 'construction_TWIA.numStories_TWIA') === undefined ? translator(messages.NotApplicable) : _.get(building, 'construction_TWIA.numStories_TWIA')
                },
                [`classCode${i}`]: {
                    value: _.get(building, 'classCode.classification') === undefined ? translator(messages.NotApplicable) : `${_.get(building, 'classCode.code')}: ${_.get(building, 'classCode.classification')}`
                },
                [`totalArea_TWIA${i}`]: {
                    value: _.get(building, 'construction_TWIA.totalArea_TWIA') === undefined ? translator(messages.NotApplicable) : _.get(building, 'construction_TWIA.totalArea_TWIA')
                },
                [`riskItemType${i}`]: {
                    value: _.get(buildingVM, 'riskItemType_TWIA') === undefined ? translator(messages.NotApplicable) : riskItem
                },
                [`roofType${i}`]: {
                    value: _.get(building, 'construction_TWIA.roofType_TWIA') === undefined ? translator(messages.NotApplicable) : roofType
                },
                [`yearBuilt${i}`]: {
                    visible: !isBuildersRisk(),
                    value: _.get(building, 'construction_TWIA.yearBuilt_TWIA') === undefined ? translator(messages.NotApplicable) :  _.get(building, 'construction_TWIA.yearBuilt_TWIA')
                },
                [`constructionStartDate${i}`]: {
                    visible: isBuildersRisk(),
                    value: _.get(building, 'construction_TWIA.constructionStartDate_TWIA') === undefined ? translator(messages.NotApplicable) : _.get(building, 'construction_TWIA.constructionStartDate_TWIA')
                },
                [`certificateOfCompliance${i}`]: {
                    visible: !isBuildersRisk(),
                    value: _.get(building, 'construction_TWIA.hasWPI8CertComplience_TWIA') === undefined ? translator(messages.NotApplicable) :  _.get(building, 'construction_TWIA.hasWPI8CertComplience_TWIA')
                },
                [`coverageForm${i}`]: {
                    visible: isBuildersRisk(),
                    value: _.get(building, 'coverageForm') === undefined ? translator(messages.NotApplicable) :  CoverageFrom
                },
                [`roofRepairsDetailsTitle${i}`]: {
                    visible: !isBuildersRisk() && !isRenewalSummary,
                },
                [`roofRepairsDetailsSection${i}`]: {
                    visible: !isBuildersRisk() && !isRenewalSummary,
                    roofAndRepairs: createRoofAndRepairs_TWIA(building)
                },
                [`buildingDetailsContainer${i}`]:{
                    visible: !isRenewalSummary
                }
            }
        });

        return Object.assign({}, ...overrides);
    }, [buildingHeader, createRoofAndRepairs_TWIA, isBuildersRisk, isRenewalSummary, location, translator, viewModelService]);

    const resolvers = {
        resolveCallbackMap: {
            buildingHeader,
            isBuildersRisk
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            CoverageSummaryAccordion,
            RoofsAndAdditionAccordion,
        },
    }

    const overrideProps = {
        '@field': {           
            className:styles.customFieldStyle // DE17182
        },
        buildings: {
            data: location?.buildings, isRenewalSummary
        },
        ...generateTopicOverrides(),
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={location}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default PolicyBuildingAccordion